<button mat-icon-button class="mat-focus-indicator mat-icon-button mat-button-base" [matMenuTriggerFor]="profileMenu">
  <app-image-with-loader [image]="(profileAvatar$ | async) || defaultAvatar"
                         [loaderDiameter]="20"
                         [width]="40"
                         [height]="40"
                         radius="20px"></app-image-with-loader>
</button>
<mat-menu #profileMenu yPosition="above">
  <a class="display-flex flex-align-center" mat-menu-item routerLink="/me">
    <mat-icon class="material-icons-outlined">face</mat-icon>
    {{ 'sideNav.usermenu.profile' | translate }}
  </a>
  <a class="display-flex flex-align-center" mat-menu-item routerLink="/logout">
    <mat-icon class="material-icons-outlined">logout</mat-icon>
    {{ 'sideNav.usermenu.logout' | translate }}
  </a>
  <app-real-conversions-menu *ngIf="appS.isAdloopTeam"></app-real-conversions-menu>
  <a class="display-flex flex-align-center"  *ngIf="appS.isAdloopTeam" mat-menu-item href='/api/admin'>
    <mat-icon class="material-icons-outlined">admin_panel_settings</mat-icon>
    {{ 'sideNav.usermenu.admin' | translate }}
  </a>
</mat-menu>
